<template>
  <div>
    <div class="container-fluid" v-show="open">
      <div class="row mb-2">
        <div class="col-10 p-0">
          <business-filter
            @businessIds="filter.business_ids = $event"
            :clearChild="clear"
          ></business-filter>
        </div>
        <div class="col-2">
          <purchase-expiry-filter
            @expiryId="filter.expiry_id = $event"
            :clearChild="clear"
          ></purchase-expiry-filter>
          <purchase-direction-filter
            @directionId="filter.direction_id = $event"
            :clearChild="clear"
            class="mt-4"
          ></purchase-direction-filter>
        </div>
        <div class="col-12 my-2 p-0">
          <purchase-dof-filter
            @dof="filter.dof = $event"
            :clearChild="clear"
          ></purchase-dof-filter>
        </div>
        <div class="col-12 text-right">
          <el-button
            class="action-btn w-5 mt-2 rounded"
            type="info"
            style="width: 65px"
            @click="clearFilter"
            >Clear</el-button
          >
          <el-button
            class="action-btn w-5 mt-2 rounded"
            type="primary"
            style="width: 65px"
            @click="key++"
            >Search</el-button
          >
          <el-button
            class="action-btn w-5 mt-2 rounded"
            type="danger"
            style="width: 65px"
            @click="open = !open"
            >Close</el-button
          >
        </div>
      </div>
    </div>

    <el-card
      shadow="always"
      v-loading="loading"
      :body-style="{ padding: '0px' }"
    >
      <div class="row">
        <div class="col-12">
          <div
            class="bg-water-blue text-dark-blue p-2 d-flex align-items-center justify-content-between"
          >
            <h3 class="mb-0 text-uppercase">Max Term Trades</h3>
          </div>
        </div>
      </div>
      <div class="row p-2">
        <div class="col-12 text-right pb-2">
          <el-input
            class="mr-2"
            size="mini"
            placeholder="Enter to search"
            style="width: 150px"
            v-model="filter.query"
            @change="key++"
            clearable
          />
          <el-button class="btn-secondary" @click="open = !open"
            >Filter</el-button
          >
        </div>
        <div class="col-12">
          <purchase-max-term
            :invoiceTypes="invoiceTypes"
            :filter="filter"
            :section="sections[0]"
            :key="key"
            @refresh="key++"
          ></purchase-max-term>
        </div>
        <div class="col-12">
          <actioned-purchase-max-term
            :invoiceTypes="invoiceTypes"
            :filter="filter"
            :section="sections[1]"
            :key="key"
            @refresh="key++"
          ></actioned-purchase-max-term>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import BusinessFilter from "../../filters/BusinessFilter.vue";
import PurchaseExpiryFilter from "../../filters/PurchaseExpiryFilter.vue";
import PurchaseDirectionFilter from "../../filters/PurchaseDirectionFilter.vue";
import InvoiceType from "../../modelsPortal/InvoiceType";
import PurchaseMaxTerm from "./components/PurchaseMaxTerm.vue";
export default {
  components: {
    BusinessFilter,
    PurchaseExpiryFilter,
    PurchaseDirectionFilter,
    PurchaseMaxTerm,
  },
  props: {},

  data() {
    return {
      query: "",
      loading: false,
      open: false,
      key: 0,
      filter: {
        business_ids: [],
        expiry_id: null,
        dof: [],
        query: "",
        direction_id: "",
      },
      sections: [
        { name: "Unactioned", id: 2 },
        { name: "Actioned", id: 1 },
      ],
      invoiceTypes: [],
      clear: 0,
    };
  },
  mounted() {
    this.getInvoiceTypes();
  },
  methods: {
    clearFilter() {
      this.filter = {
        business_ids: [],
        expiry_id: null,
        dof: [],
        query: "",
        direction_id: "",
      };
      this.clear++;
      this.key++;
    },
    getInvoiceTypes() {
      new InvoiceType()
        .whereIn("id", [1, 2])
        .get()
        .then((result) => {
          this.invoiceTypes = result;
        })
        .catch((err) => {});
    },
  },
};
</script>
